import React from 'react';

// Routes
import { Routes } from './routes';

function App() {
  return (
    <Routes />
  );
}

export default App;
